import { setBlockTracking as _setBlockTracking, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b229e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Clippy Cloud")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Easy way to upload and share files quickly for free and no login required. ")
const _hoisted_3 = { class: "SectionHero__actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Upload Files ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("My Uploads")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Text = _resolveComponent("Text")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Container = _resolveComponent("Container")!

  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createElementVNode("section", { class: "SectionHero" }, [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, { level: "1" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_Text, { class: "SectionHero__description" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              theme: "primary",
              "data-testid": "primary-button",
              onClick: _ctx.navigateToUpload
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              "data-testid": "secondary-button",
              onClick: _ctx.navigateToMyUploads
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _setBlockTracking(1),
    _cache[0]
  )
}